import { Breakpoints } from '@greencross/utils/breakpoints';
import styled from 'styled-components';

export const ProfilePageStyled = styled.div``;

export const ProfilePageContentStyled = styled.div`
  position: relative;
  min-height: 1160px;
  padding: 48px 0;
  .background-image {
    background-color: #73c4d7;
  }
  @media screen and (max-width: ${Breakpoints.XL}) {
    padding: 63px 0;
  }
`;
